import React from 'react'
import NavAdmin from '../Components/AdminNav/NavAdmin'
import OrdersAll from '../Components/Orders/OrdersAll'

function Orders() {
  return (
    <div>
        <NavAdmin></NavAdmin>
        <OrdersAll></OrdersAll>
    </div>
  )
}

export default Orders